import EntityBase from '@/data/EntityBase';
import type EntityState from '@/data/EntityState';
import type RipplingMigrationStatus from '@/data/migration/model';

export default class MigrationState extends EntityBase<
  EntityState,
  { migrationStatus: RipplingMigrationStatus | null }
>({
  migrationStatus: null,
}) {}
